<template>
	<select class="form-select form-select-sm" :value="modelValue" @change="$emit('update:modelValue', $event.target.value)">
		<option v-for="v in valute" :key="v" :value="v">{{ v }}</option>
	</select>
</template>

<script>
// Codici valuta degli stati (CORE_GEO_STATI.CURRENCY), EUR in cima
export default {
	name: 'SelectValuta',
	props: {
		modelValue: { type: String, default: 'EUR' }
	},
	emits: ['update:modelValue'],
	computed: {
		valute() {
			const codici = [...new Set(this.$root.arrayGeoStati.map(s => s.CURRENCY).filter(c => c && c != 'EUR'))].sort();
			return ['EUR', ...codici];
		}
	}
}
</script>
